import * as ProjectActionType from 'Projects/constants';
import * as LotActionType from 'Lots/constants';

class MaintenanceService {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  getTaskList(projectId, taskType, callback) {
    this.dispatch({
      type: ProjectActionType.GET_MAINTENANCE_TASK_LIST_ASYNC,
      params: {
        projectId: projectId,
        taskType: taskType
      },
      callback: callback
    });
  }

  removeTaskById(taskId, isGeneralTask, callback) {
    this.dispatch({
      type: ProjectActionType.DELETE_MAINTENANCE_TASK_ASYNC,
      params: {
        id: taskId,
        isGeneralTask: isGeneralTask
      },
      callback: callback
    });
  }

  getTaskReminderList(lot, fromDate, toDate, callback) {
    const { builderProfile } = lot.extensionValue;

    this.dispatch({
      type: LotActionType.GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_ASYNC,
      params: {
        lotId: lot.value,
        fromDate: fromDate,
        toDate: toDate,
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        }
      },
      callback: callback
    });
  }

  updateReminder(item, status, lot, callback) {
    const { builderProfile } = lot.extensionValue;
    if (item.id) {
      this.dispatch({
        type: LotActionType.PATCH_TASK_REMINDER_WITH_ID_ASYNC,
        params: {
          id: item.id,
          isChecked: status,
          isGeneral: !item.inventoryItem,
          builderHost: builderProfile.builderHost,
          LotId: lot.value,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        },
        callback
      });
    }
    else {
      this.dispatch({
        type: LotActionType.PATCH_TASK_REMINDER_WITHOUT_ID_ASYNC,
        params: {
          MSId: item.msId.toString(),
          LotId: lot.value.toString(),
          InventoryItemId: (item.inventoryItem && item.inventoryItem.id) || null,
          RecurringType: item.recurringType.toString(),
          RepeatType: item.repeatType.toString(),
          RepeatTypeStart: item.repeatTypeStart.toString(),
          RepeatTypeEnd: item.repeatTypeEnd.toString(),
          RemindDate: item.remindDate,
          builderHost: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        },
        callback
      });
    }
  }

  buildUrlToInventoryItem(lotId, itemId) {
    return `/home-hub?tab=home-inventory&subTab=category-items&lotId=${lotId}&itemId=${itemId}`;
  }
}

export default MaintenanceService;



// WEBPACK FOOTER //
// ./src/Lots/Components/Maintenance/services.js